module.exports = __webpack_public_path__ + "static/media/Home-TanCircle1.2034bc91.svg";